module.exports = __webpack_public_path__ + "media/stylesheets/images/mattrz_lp/logos/logo-06-aa6e790fd44f2237352e73708741c92f.png";